import type { FormSpaceMode } from '@/types/forms'

export interface FormsSpaceConfig {
  mode: FormSpaceMode
}

export const defaultFormsConfig = (): FormsSpaceConfig => ({ mode: 'multi' })

/** Absent or anything else in the stored config means "several forms". */
export const formsConfigOf = (moduleConfig: Record<string, unknown> | null | undefined): FormsSpaceConfig => ({
  mode: moduleConfig?.mode === 'single' ? 'single' : 'multi'
})

/** `PUT /spaces` refuses "one form" on a space with two or more: the message goes under the choice. */
export const formsConfigApiErrors = (err: unknown): { mode: string } | null => {
  const data = (err as { response?: { status?: number; data?: { message?: string; errors?: { param?: string; message?: string }[] } } } | null)?.response
  const hit = data?.data?.errors?.find((e) => e.param === 'moduleConfig.mode' || e.param === 'mode')
  if (!hit && data?.status !== 409) return null
  return { mode: hit?.message || data?.data?.message || '' }
}

/** The form a one-form space is born with: the title (and an optional intro); the fields come in the editor. */
export interface FormDraft {
  title: string
  description: string
}

export const emptyFormDraft = (): FormDraft => ({ title: '', description: '' })
